import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from '@ant-design/icons';

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin
} from "antd";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';
import dayjs from "dayjs";

const { Text } = Typography

const Disbursal = (props) => {

  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [prepaymentOptionsData, setPrepaymentOptionsData] = useState([]);
  const [paymentTypeData, setPaymentTypeData] = useState([]);

  useEffect(() => {
    getTemplate();
  }, []);


  function getTemplate() {


    const params = {
      command: "disburse"
    }
    const url = `${apiConfig.Loans}/${state.id}/transactions/template`

    let body = {
      session,
      params
    };

    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;

        console.log(objList)

        let tempPaymentTypeData = [];

        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeData.push({
            value: element.id,
            label: element.name,
          });
        });

        setPaymentTypeData(tempPaymentTypeData);

        useForm.setFieldsValue({
          transactionAmount: objList?.amount,
          actualDisbursementDate: dayjs(BOM.FormatArrayDateWithoutYear(objList?.date)),
          paymentTypeId: objList?.paymentTypeOptions[0].name,
        });
      }
    });
  }


  function onCancel() {
    navigate("/detail-group-loan", { state: state });
  }

  const onSubmit = (formValues) => {

    formValues.actualDisbursementDate = BOM.DateTime(formValues.actualDisbursementDate, "only-date")

    const params = {
      command: "disburse"
    }
    const url = `${apiConfig.Loans}/${state.id}`

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
      params
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.loanDisbursementMsg);
        navigate("/detail-group-loan", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  return (

    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.loanDisbursal}
        pageItems={staticConfig.loanDisbursalBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}

          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.disbursedOnDate}
                  name="actualDisbursementDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.disbursedOnDate
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.disbursedOnDate}`,
                      "select"
                    )}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionAmount}
                  name="transactionAmount"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.transactionAmount}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>


              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.paymentTypes}
                  name={"paymentTypeId"}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.paymentTypes,
                      "select"
                    )}
                    options={paymentTypeData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">{"Show Payment Details"}</Divider>


              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.accountNumber}
                  name="accountNumber"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.accountNumber}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.chequeNumber}
                  name="checkNumber"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.chequeNumber}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.routingCode}
                  name="routingCode"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.routingCode}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.receiptNumber}
                  name="receiptNumber"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.receiptNumber}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.bankNumber}
                  name="bankNumber"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.bankNumber}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

            </Row>


            <Row>
              <Divider />
              {BOM.HasPermission("DISBURSE_LOAN") &&
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>

        </Card>
      </Spin>

    </MainLayout>
  )
}

export default Disbursal